import type { Meta } from '@brighterly/lib-core-types/api/interfaces'
import type { UsersStore } from './interfaces'

import { isFullArray } from '@helpers/array'

export const getters = {
  isLoading: (state: UsersStore): UsersStore['loading'] => state.loading,
  isSaving: (state: UsersStore): UsersStore['saving'] => state.saving,
  getUsers: (state: UsersStore): UsersStore['users'] => state.users,
  hasUsers: (state: UsersStore): boolean => isFullArray(state.users),
  getTeams: (state: UsersStore): UsersStore['teams'] => state.teams,
  getMeta: (state: UsersStore): Meta | null => state.meta,
  getFilterSearch: (state: UsersStore): UsersStore['filterSearch'] => state.filterSearch,
  getFilterRoles: (state: UsersStore): UsersStore['filterRoles'] => state.filterRoles,
  getFilterTeams: (state: UsersStore): UsersStore['filterTeams'] => state.filterTeams,
  getFilterStatus: (state: UsersStore): UsersStore['filterStatus'] => state.filterStatus,
  getCurrentPage: (state: UsersStore): UsersStore['currentPage'] => state.currentPage,
  getPerPage: (state: UsersStore): UsersStore['perPage'] => state.perPage,
  getUserToDelete: (state: UsersStore): UsersStore['userToDelete'] => state.userToDelete,
  isModalDelete: (state: UsersStore): boolean => state.userToDelete !== null,
  getCurrentUser: (state: UsersStore): UsersStore['currentUser'] => state.currentUser,
}
